export const ADVDISTRDATA = 'ADVDISTRDATA';
export const DLVTRAKITEMS = 'DLVTRAKITEMS';
export const DLVTRACKS = 'DLVTRACKS';
export const DLVADDRESSSUM = 'DLVADDRESSSUM';
export const DLVADDRESSSUMDET = 'DLVADDRESSSUMDET';
export const LORRIES = 'LORRIES';
export const LORRYTYPES = 'LORRYTYPES';
export const DEFAULTDISTRLINE = 'DEFAULTDISTRLINE';
export const DLVGROUPS = 'DLVGROUPS';
export const DLVZONEGROUPS = 'DLVZONEGROUPS';
export const DLVDISTRLINEGROUPS = 'DLVDISTRLINEGROUPS';
export const DLVCAPABILITYGROUPS = 'DLVCAPABILITYGROUPS';

// hidden DLVADDRESSSUMDET form id
export const DLVTRACKI = 'DLVTRACKI';
// hidden DLVTRACKS form id
export const DLVTRACK = 'DLVTRACK';
//hidden ADVDISTRDATA  form id
export const DOCGUID = 'DOCGUID';
export const UNLOADTIME = 'UNLOADTIME';
export const FROMTIME = 'FROMTIME';
export const TOTIME = 'TOTIME';
export const TYPECODE = 'TYPECODE';
export const DOCCODE = 'DOCCODE';
export const OPTDATE = 'OPTDATE';
export const OPTIMIZED = 'OPTIMIZED';
export const ZONE = 'ZONE';
export const DISTRLINE = 'DISTRLINE';
export const TOTDOCS = 'TOTDOCS';
export const CAPABILITYCODE = 'CAPABILITYCODE';
export const CAPABILITY = 'CAPABILITY';
export const NUMLINE = 'NUMLINE';
export const VOLUME = 'VOLUME';
export const WEIGHT = 'WEIGHT';
export const NWEIGHT = 'NWEIGHT';
export const STATUS_FIELD = 'STATDES';

export const TOTORDERS = 'TOTORDERS';

export const GPSX = 'GPSX';
export const GPSY = 'GPSY';
export const TODOREF = 'TODOREF';
export const REFNUM = 'REFNUM';
export const REFDES = 'REFDES';

// Storage keys
export const SELECTED_VIEW_TYPE_STORE_KEY = 'SELECTED_ADP_VIEW_TYPE';
export const SELECTED_PLANNED_FIELDS_STORE_KEY = 'ADVDISTRDATA_SELECTED_FIELDS';
export const SELECTED_ROUTE_TITLE_FIELDS_STORE_KEY = 'DLVTRACKS_SELECTED_TITLE_FIELDS';
export const SELECTED_ROUTE_TOTALS_FIELDS_STORE_KEY = 'DLVTRACKS_SELECTED_TOTALS_FIELDS';
export const SELECTED_ROUTE_TABLE_FIELDS_STORE_KEY = 'DLVADDRESSSUMDET_SELECTED_FIELDS';
export const PLANNED_COLS_WIDTH_DICT_STORE_KEY = 'PLANNED_COLUMNS_WIDTH_DICTIONARY';
export const ROUTE_TABLE_COLS_WIDTH_DICT_STORE_KEY = 'ROUTE_TABLE_COLUMNS_WIDTH_DICTIONARY';
export const SHOW_TOTALS_FOR_ALL_STORE_KEY = 'SHOW_TOTALS_FOR_ALL_STORE_KEY';
export const MAP_SETTINGS_STORE_KEY = 'MAP_SETTINGS_STORE_KEY';
export const ROUTE_SHOW_TYPE_STORE_KEY = 'ROUTE_SHOW_TYPE_STORE_KEY';

// procedures

// loading documents to ADVDISTRDATA (with user input)
export const LOADADVDISTRDATA = 'LOADADVDISTRDATA';

// loading documents to ADVDISTRDATA (without user input, on the basis of the previously saved parameters)
export const LOADADVDISTRDATANOI = 'LOADADVDISTRDATANOI';

// moving documents from ADVDISTRDATA to DLVTRACKS
export const ADDTODLVTRACKITEMS = 'ADDTODLVTRACKITEMS';

// moving documents between DLVTRACKS rows and from DLVTRACKS to ADVDISTRDATA
export const MOVEDLVTRACKITEMS = 'MOVEDLVTRACKITEMS';

// Automatic scheduling to delivery: moving documents to a delivery plan
export const ADDDOCSTODELPLAN = 'ADDDOCSTODELPLAN';

// changing locations order in one route
export const UPDDELIVERYORDER = 'UPDDELIVERYORDER';

export const OPTDELIVERYORDER = 'OPTDELIVERYORDER';
export const OPENANDOPTDELIVERY = 'OPENANDOPTDELIVERY';

export enum ColumnsNamesForRoutes {
    DISTRDATE = 'DISTRDATE',
    DLVTRACKNUM = 'DLVTRACKNUM',
    DLVTRACK = 'DLVTRACK',
    SHIPPERDES = 'SHIPPERDES',
    STATDES = 'STATDES',
    DISTRLINEDES = 'DISTRLINEDES',
    ROUNDNUM = 'ROUNDNUM',
    TOTWEIGHT = 'TOTWEIGHT',
    TOTPRICE = 'TOTPRICE',
    TOTQUANT = 'TOTQUANT',
    TOTCUSTS = 'TOTCUSTS',
    TOTDOCS = 'TOTDOCS'
}

export const routeColors = [
    '#FF0000',
    '#0000FF',
    '#00FF00',
    '#800080',
    '#FFC0CB',
    '#40E0D0',
    '#8B4513',
    '#FF00FF',
    '#00008B',
    '#90EE90',
    '#8B0000',
    '#87CEEB',
    '#006400',
    '#FF1493',
    '#6A5ACD',
    '#4682B4',
    '#556B2F',
    '#FF8C00'
];

export enum ColumnsNamesForRoutesSubform {
    STATE = 'STATE',
    ADDRESS = 'ADDRESS'
}

export const DLVSTARTROUTEADDRESS = 'DLVSTARTROUTEADDRESS';
export const DLVENDROUTEADDRESS = 'DLVENDROUTEADDRESS';

export enum ColumnsNamesForLocationsSubform {
    DISTRORDER = 'DISTRORDER',
    DOCCODE = 'DOCCODE',
    TOTQUANT = 'TOTQUANT',
    CDES = 'CDES',
    SDES = 'SDES',
    NWEIGHT = 'NWEIGHT',
    TOTPRICE = 'TOTPRICE',
    FROMTIME = 'FROMTIME',
    TOTIME = 'TOTIME',
    DOCCODEDES = 'DOCCODEDES',
    PACKNUM = 'PACKNUM',
    KLINE = 'KLINE',
    UNLOADTIME = 'UNLOADTIME'
}

export const DEFAULT_TABLE_COLUMNS = ['CDES', 'ADDRESS', 'STATE', 'TODOREF'];

export enum ColumnsNamesForLorries {
    LORRYNUM = 'LORRYNUM',
    LORRYDES = 'LORRYDES',
    SHIPPERNAME = 'SHIPPERNAME',
    SHIPPERDES = 'SHIPPERDES',
    LTCODE = 'LTCODE',
    LTDES = 'LTDES',
    DLVGROUPCODE = 'DLVGROUPCODE',
    DLVGROUPDES = 'DLVGROUPDES',
    OPTIMIZATION = 'OPTIMIZATION',
    LORRY = 'LORRY'
}

export enum ColumnsNamesForLorryTypes {
    LTCODE = 'LTCODE',
    LTDES = 'LTDES',
    LTWEIGHT = 'LTWEIGHT',
    UNITNAME = 'UNITNAME',
    LTVOLUME = 'LTVOLUME',
    VUNITNAME = 'VUNITNAME',
    LORRYTYPE = 'LORRYTYPE'
}

export enum ColumnsNamesForLorriesSubform {
    DISTRLINECODE = 'DISTRLINECODE',
    DISTRLINEDES = 'DISTRLINEDES',
    WARHSNAME = 'WARHSNAME',
    LOCNAME = 'LOCNAME',
    SGPSX = 'SGPSX',
    SGPSY = 'SGPSY',
    ENDWARHSNAME = 'ENDWARHSNAME',
    ENDLOCNAME = 'ENDLOCNAME',
    EGPSX = 'EGPSX',
    EGPSY = 'EGPSY',
    DISTRLINE = 'DISTRLINE'
}

export enum ColumnsNamesForDeliveryGroups {
    DLVGROUPCODE = 'DLVGROUPCODE',
    DLVGROUPDES = 'DLVGROUPDES',
    ALLROUTES = 'ALLROUTES',
    ALLZONES = 'ALLZONES',
    ALLCAPABILITIES = 'ALLCAPABILITIES',
    DLVGROUP = 'DLVGROUP'
}

export enum ColumnsNamesForDeliveryDistributionRoutesForGroups {
    DISTRLINE = 'DISTRLINE',
    OPPTIMIZATION = 'OPPTIMIZATION',
    DISTRLINECODE = 'DISTRLINECODE',
    DISTRLINEDES = 'DISTRLINEDES',
    DLVDISTRLINEGROUP = 'DLVDISTRLINEGROUP',
    DLVGROUP = 'DLVGROUP'
}

export enum ColumnsNamesForDeliveryZonesForGroups {
    ZONE = 'ZONE',
    OPPTIMIZATION = 'OPPTIMIZATION',
    ZONECODE = 'ZONECODE',
    ZONEDES = 'ZONEDES',
    DLVGROUP = 'DLVGROUP',
    DLVZONEGROUP = 'DLVZONEGROUP'
}

export enum ColumnsNamesForDeliveryCapabilitiesForGroups {
    OPTIMIZATION = 'OPTIMIZATION',
    CAPABILITYCODE = 'CAPABILITYCODE',
    CAPABILITYDES = 'CAPABILITYDES',
    CAPABILITY = 'CAPABILITY',
    DLVCAPABILITYGROUP = 'DLVCAPABILITYGROUP',
    DLVGROUP = 'DLVGROUP'
}

export enum ColumnsNamesForMarkers {
    STATE = 'STATE',
    USERLOGIN = 'USERLOGIN',
    ADDRESS = 'ADDRESS',
    ADDRESS2 = 'ADDRES2',
    ADDRESS3 = 'ADDRESS3',
    COUNTRYNAME = 'COUNTRYNAME',
    STATENAME = 'STATENAME',
    CELLPHONE = 'CELLPHONE',
    LATITUDE = 'GPSX',
    LONGITUDE = 'GPSY',
    ROUTEID = 'ROUTEID',
    ZIP = 'ZIP',
    CUSTDES = 'CUSTDES'
}

export const ColumnsNamesForMarkersType = [
    'STATE',
    'USERLOGIN',
    'ADDRESS',
    'ADDRES2',
    'ADDRESS3',
    'COUNTRYNAME',
    'STATENAME',
    'CELLPHONE',
    'GPSX',
    'GPSY',
    'ROUTEID',
    'ZIP',
    'CUSTDES'
];

export const DEFAULT_PLANNED_COLUMNS = [
    'TODOREF',
    'LINE',
    'CURDATE',
    'CUSTDES',
    'ADDRESS',
    'STATE'
];

export const DEFAULT_DELI_TITLE_COLUMNS = [
    ColumnsNamesForRoutes.DISTRDATE,
    ColumnsNamesForRoutes.DLVTRACKNUM,
    ColumnsNamesForRoutes.STATDES,
    ColumnsNamesForRoutes.DISTRLINEDES,
    ColumnsNamesForRoutes.ROUNDNUM
];

export const DEFAULT_DELI_TOTALS_COLUMNS = [
    ColumnsNamesForRoutes.TOTCUSTS,
    ColumnsNamesForRoutes.TOTDOCS,
    ColumnsNamesForRoutes.TOTWEIGHT
];

// Numeric constants
export const ADPFetchMax = 300;
export const distanceThreshold = 50; // Adjust this value for sensitivity
export const DEFAULT_COLUMN_WIDTH = 140;
export const MIN_COLUMN_WIDTH = 80;
export const MAX_COLUMN_WIDTH = 320;

export const PLANNED_BLOCK = 'planned-block';
export const DELIVERY_BLOCK = 'delivery-block';

export enum ViewType {
    ALL = 'all',
    MAP = 'map',
    BIG_MAP = 'big_map',
    ROUTES_MAP = 'routes_map',
    PLANNED_MAP = 'planned_map',
    ONLY_ROUTES = 'only_routes',
    ONLY_PLANNED = 'only_planned'
}

export enum EditingFieldsType {
    Planned = ADVDISTRDATA,
    RouteTitle = DLVTRACKS,
    RouteTileTotals = `${DLVTRACKS}_TOTALS`,
    RouteTable = DLVADDRESSSUMDET
}

export enum DataTestIds {
    deliveryDateInput = 'deliveryDateInputTestId',
    deliveryDateClearBtn = 'deliveryDateClearBtnTestId',
    datePicker = 'datePickerTestId',
    dialogInstructions = 'dialogInstructionsTestId',
    confirmBtn = 'confirmBtnTestId',
    routesHeaderSettingsBtn = 'routesHeaderSettingsBtnTestId',
    routesHeaderExpandedTrigger = 'routesHeaderExpandedTrigger',
    optimizeRouteButton = 'optimizeRouteButtonId',
    optimizeUnassignedButton = 'optimizeUnassignedButtonId',
    cancelButton = 'cancelButtonId',
    runButton = 'runButtonId',
    optimizationDialogId = 'optimizationDialog',
    optimizationCancelDialogId = 'optimizationCancelDialog',
    optimizationResultsDialogId = 'optimizationResultsDialog',
    optimizationLoaderCancelButtonId = 'optimizationLoaderCancelButton'
}

export const DND_PLACEHOLDER_HEIGHT = 32;
